import type { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

/** Links to `/prompts/:key/evaluations` (where you can act), not the
 *  read-only page. Encoded — a key is free text. */
export const PromptLink: FC<{ promptKey: string; children?: ReactNode }> = ({ promptKey, children }) => (
  <Link
    to={`/prompts/${encodeURIComponent(promptKey)}/evaluations`}
    className="text-rio-700 underline decoration-dotted underline-offset-2 hover:text-rio-800"
  >
    {children ?? promptKey}
  </Link>
);
